import React from 'react'
import About from '../public/about/About'
import ManuOperation from './navOperationRoom/ManuOperation'

function AboutLaboratory() {
    return (
        <div>
            <ManuOperation />
            <About disabledMenu />
        </div>
    )
}

export default AboutLaboratory